module.exports = __webpack_public_path__ + "img/icone_imã.01885901.png";